import { render, staticRenderFns } from "./VipServiceCreateView.vue?vue&type=template&id=01dfca5a"
import script from "./VipServiceCreateView.vue?vue&type=script&lang=js"
export * from "./VipServiceCreateView.vue?vue&type=script&lang=js"
import style0 from "./VipServiceCreateView.vue?vue&type=style&index=0&id=01dfca5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports